import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarCheck2, MessageCircleQuestion } from "lucide-react";
import { WHATSAPP_URL, BOOK_PERIO_PATH } from "./data";
import { WaIcon } from "./WhatsAppFab";

const iconBtn = "grid place-items-center w-12 h-12 rounded-full shrink-0 active:scale-95 transition-transform";

export const MobileActionBar = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    document.body.classList.add("has-mobile-bar");
    return () => { window.removeEventListener("scroll", onScroll); document.body.classList.remove("has-mobile-bar"); };
  }, []);
  const onBookingPage = pathname === BOOK_PERIO_PATH;
  return (
    <AnimatePresence>
      {show && (
        <motion.nav initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          aria-label="Azioni rapide" data-testid="mobile-action-bar"
          className="lg:hidden fixed inset-x-0 bottom-0 z-[60] bg-[#FCFBF7]/90 backdrop-blur-xl border-t border-[#1B3B28]/10 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
          <div className="flex items-center gap-2.5">
            {onBookingPage ? (
              <a href="#booking-form-anchor" onClick={(e) => { e.preventDefault(); document.querySelector('[data-testid="booking-form"]')?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
                data-testid="mobile-bar-booking" className="flex-1 flex items-center justify-center gap-2 h-12 rounded-full bg-[#1B3B28] text-[#FCFBF7] text-[15px] font-medium active:scale-[0.98] transition-transform">
                <CalendarCheck2 size={17} /> Vai al modulo
              </a>
            ) : (
              <Link to={BOOK_PERIO_PATH} data-testid="mobile-bar-booking" className="flex-1 flex items-center justify-center gap-2 h-12 rounded-full bg-[#1B3B28] text-[#FCFBF7] text-[15px] font-medium active:scale-[0.98] transition-transform">
                <CalendarCheck2 size={17} /> Prenota la visita
              </Link>
            )}
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Scrivici su WhatsApp" data-testid="mobile-bar-whatsapp" className={`${iconBtn} bg-[#3E6B48] text-[#FCFBF7]`}>
              <WaIcon />
            </a>
            <button type="button" onClick={() => window.dispatchEvent(new Event("open-chat"))} aria-label="Fai una domanda all'assistente" data-testid="mobile-bar-chat" className={`${iconBtn} bg-[#E6ECE4] text-[#1B3B28]`}>
              <MessageCircleQuestion size={20} />
            </button>
          </div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
};
